var map = {
	"./arrows.webm": "fb58",
	"./buzzer_eat-in.webm": "0754",
	"./buzzer_eat-in_radio.webm": "79b0",
	"./buzzer_takeaway.webm": "2867",
	"./buzzer_takeaway_selfservice.webm": "920a",
	"./green_checkmark.webm": "0b1b",
	"./loudspeaker.webm": "becf",
	"./loudspeaker_selfservice.webm": "ccd2",
	"./orderscreen.webm": "d85c",
	"./orderscreen_selfservice.webm": "e616",
	"./payment.webm": "bb4a",
	"./payment_cash.webm": "fa7a",
	"./print.webm": "247b",
	"./products_of_the_shelf.webm": "d92a",
	"./products_of_the_shelf_scanned.webm": "9d32",
	"./red_checkmark.webm": "b48e",
	"./red_cross.webm": "2cd7",
	"./scan.webm": "f3db",
	"./table_service.webm": "61cc",
	"./table_tent.webm": "a951"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c345";